interface ISpinnerProps {
    styles?: Record<string, string>;
}

export default function Spinner({ styles }: ISpinnerProps) {
    return (
        <div style={{ ...styles } }>
            <span className="sk-wave" style={{ display: 'inline-flex', marginRight: '0px', marginTop: '10px', textAlign: 'center' }} >
                <span className="sk-wave-rect" style={{ backgroundColor: "red" }}></span>
                <span className="sk-wave-rect" style={{ backgroundColor: "red" }}></span>
                <span className="sk-wave-rect" style={{ backgroundColor: "red" }}></span>
                <span className="sk-wave-rect" style={{ backgroundColor: "red" }}></span>
                <span className="sk-wave-rect" style={{ backgroundColor: "red" }}></span>
            </span>
        </div>
    )
}
